import './styles/index.css';
import './styles/approved-index.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { IntlProvider } from 'react-intl';

function enableTooltips() {
    // @ts-ignore
    $(() => {
        $('[data-toggle="tooltip"]').tooltip()
    });
}

ReactDOM.render(
    <IntlProvider locale='en'>
        <App />
    </IntlProvider>,
    document.getElementById('root') as HTMLElement
);
registerServiceWorker();
enableTooltips();



// WEBPACK FOOTER //
// ./src/index.tsx